const formatPhone = (phone, locale) => {
    const clean = (phone || '').replace(/\D/g, '');
    const m = clean.match(/^(?:(\d*?)(\d{1,3}))?(\d{3})(\d{2})(\d{2})$/);

    if (m) {
        const [, cc, operator, ...parts] = m;
        let local = parts.join(cc ? ' ' : '-');

        if (operator) {
            local = (cc ? operator : `(${operator})`) + ' ' + local;
        }

        if (cc) {
            local = `+${cc} ` + local;
        }

        return local;
    }

    return phone || '';
};

export function normalizePhone(value, maxLength = 18, lenient = true) {
    const len = (value && value.length) || 0;

    if (len === 0) return '';

    const phone = (lenient || value.indexOf('+') >= 0 ? '+' : '') + value.replace(/\D/g, '');

    return phone.slice(0, maxLength);
}

export default formatPhone;
